var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({class:['gl-icon', 
           ("gl-icon--" + _vm.name), 
           {'gl-icon--light': _vm.light, 
            'gl-icon--disabled': _vm.disabled, 
            'gl-icon--warn': _vm.warn,
            'gl-icon--dark': _vm.dark}],attrs:{"height":_vm.height,"width":_vm.width}},_vm.$listeners),[_c('use',{attrs:{"href":_vm.spriteHref}})])}
var staticRenderFns = []

export { render, staticRenderFns }